<template>
  <layout-default :hide-footer-mobile="true">
    <link
      rel="stylesheet"
      href="https://use.fontawesome.com/releases/v5.7.0/css/all.css"
      integrity="sha384-lZN37f5QGtY3VHgisS14W3ExzMWZxybE1SJSEsQp9S+oqd12jhcu+A56Ebc1zFSJ"
      crossorigin="anonymous"
    />
    <steps-header :current-step="1"></steps-header>
    <div class="step-1-content">
      <div
        id="programInscription"
        data-aos="fade-in"
        data-aos-duration="1500"
        data-aos-once="true"
      >
        <div class="pdv-container">
          <div class="custom-padding">
            <div class="div-alinear md-5 relative">
              <div class="item">
                <div
                  class="col-12 m-title no-padding"
                  v-if="showLocationsAndCourses"
                >
                  <h4 class="h4-header-title">Tus clases comienzan aquí</h4>
                  <p class="p-subtitule-title">
                    Selecciona en pocos pasos tu sede, mes de inicio de tus
                    clases y los cursos que deseas tomar.
                  </p>
                </div>

                <div v-if="!showLocationsAndCourses">
                  <h4 class="h4-header-title">
                    Tus clases online comienzan aquí
                  </h4>
                  <p class="p-subtitule-title">
                    Selecciona en pocos pasos el mes de inicio de tus cursos y
                    los programas que desas tomar.
                  </p>
                  <div class="seccion-separator"></div>
                </div>
                <div class="col-md-12 no-padding">
                  <div class="pdv-form-group">
                    <div v-if="showLocationsAndCourses">
                      <h4 class="question-form d-flex mb-4">
                        <div class="circulo"><span>1</span></div>
                        ¿En qué sede quieres estudiar?
                      </h4>
                      <div class="row">
                        <div class="col-md-6 pdv-search-select">
                          <label
                            class="form-label-multiselect"
                            for="communeSelect"
                            >Comuna de la sede</label
                          >
                          <multiselect
                            v-if="availableCities.length"
                            v-model="selectedCommune"
                            :options="availableCities"
                            placeholder="Elige tu comuna"
                            label="name"
                            :showLabels="false"
                            class="multiselect-custom"
                            @input="onSelectLocation"
                          >
                            <span slot="noResult"
                              >No se encontraron resultados.</span
                            >
                          </multiselect>
                        </div>
                        <div
                          :class="{
                            invisible:
                              !selectedCommune ||
                              availableLocations.length <= 1,
                          }"
                          class="col-md-6 location-container"
                        >
                          <div class="form-group custom-select2-container">
                            <label for="locationSelect">Sede</label>
                            <select
                              class="pdv-custom-select"
                              v-model="selectedLocation"
                              v-select2="selectedLocation"
                              v-on:change="coursesHandler"
                              name="locationSelect"
                              id="locationSelect"
                            >
                              <option
                                v-for="location in availableLocations"
                                v-bind:value="location.id"
                                v-bind:key="location.id"
                              >
                                {{ location.name }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Si no es online o PDVX-->
                    <div v-if="selectedLocationInfo && showLocationsAndCourses">
                      <div class="flex">
                        <h4 class="question-form d-flex mb-4">
                          <div class="circulo"><span>2</span></div>
                          Selecciona el mes de inicio de tu programa
                        </h4>
                      </div>
                      <div class="row mb-4 ml-1">
                        <!--div class="col-12" v-if="countMounth()">
                          <h4 class="question-form d-flex">
                            <div class="circulo">2</div>
                            Selecciona el mes de inicio de tu programa
                          </h4>
                        </div-->
                        <div class="col-12 no-padding">
                          <div class="row mb-1" v-if="countMounth()">
                            <!-- countMounth() esto no lo he terminado-->
                            <b-row class="mb-1">
                              <b-col
                                v-for="(mes, i) in meses_enable"
                                :key="i"
                                cols="4"
                                sm="12"
                                xs="12"
                                class="ml-3 mb-2"
                              >
                                <button
                                  class="month-container"
                                  v-if="mes.value"
                                  @click="handleMounth(i)"
                                  :class="mes.addItem ? ' deactive' : 'active'"
                                >
                                  <i class="far fa-calendar-alt" />
                                  <span>{{ getMounth(i) }}</span>
                                </button>
                              </b-col>
                            </b-row>

                            <div
                              v-for="(mes, i) in meses_enable"
                              :key="i"
                              style="width: 100% !important"
                            >
                              <div
                                class="col-12 month-start mt-2 mb-2 pl-0"
                                v-if="mes.addItem"
                              >
                                <p class="mb-0">
                                  Las clases
                                  <span v-if="presente">inician </span>
                                  <span v-else>iniciadas</span> el
                                  <span
                                    style="
                                      text-transform: capitalize;
                                      font-family: Arial, Helvetica, sans-serif;
                                    "
                                    >{{ getDate(i) }}</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                          <div v-else>
                            <div
                              v-for="(mes, i) in meses_enable"
                              :key="i"
                              style="width: 100% !important"
                            >
                              <div
                                class="col-12 month-start no-padding"
                                v-if="mes.addItem"
                              >
                                <div
                                  class="cards-programs"
                                  :class="{ 'border-card': unique == '1' }"
                                  @click="changeSelected('1')"
                                >
                                  <div class="cards-programs-info">
                                    <img
                                      src="/images/featured/icon-calendar.svg"
                                      class=""
                                      alt="icon-primero"
                                    />
                                    <p>
                                      Las clases
                                      <span v-if="presente">inician </span>
                                      <span v-else>iniciadas</span> el
                                      <span>{{ getDate(i) }} </span>
                                      <span
                                        v-if="one_mes"
                                        style="display: none"
                                        >{{ handleOneMonth(i) }}</span
                                      >
                                    </p>
                                  </div>
                                  <div class="cards-programs-input">
                                    <input
                                      type="radio"
                                      name="programa"
                                      value="1"
                                      v-model="unique"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- countMounth() fin-->
                      </div>

                      <div class="seccion-separator"></div>

                      <div
                        :class="{ 'element-disabled': !selectedLocationInfo }"
                        class="row mb-4 ml-1"
                      >
                        <div
                          class="col relative no-padding"
                          v-if="mes_select != null"
                        >
                          <h4 class="question-form d-flex mb-4">
                            <div class="circulo">
                              {{ countMounth() ? "3" : "3" }}
                            </div>
                            ¿Qué cursos quieres agregar a tu programa?
                          </h4>
                          <div class="row">
                            <div class="col-md-12 no-padding">
                              <div class="row">
                                <div
                                  class="academic-programs pdv-form-group col-12 col-md-6 col-sm-12 col-xs-12"
                                  v-for="course in courses"
                                  v-bind:key="course.id"
                                  v-if="
                                    (course.name === 'Matemática' ||
                                      course.name === 'Matemática Electivo') &&
                                    course.mes === mes_select
                                  "
                                >
                                  <div class="col-md-12">
                                    <div class="custom-checkbox-cont">
                                      <input
                                        @change="disabledMatchCourse(course.id)"
                                        type="checkbox"
                                        v-model="course.checked"
                                        :name="course.name"
                                        :id="course.subject.name + course.id"
                                        class="default"
                                      />
                                      <label
                                        :class="{
                                          'element-disabled': course.disabled,
                                          chequiado: course.checked,
                                        }"
                                        @click="ErrorSubmit = false"
                                        :for="course.subject.name + course.id"
                                        class="checkbox-label"
                                      >
                                        <div
                                          class="pdv-custom-checkbox"
                                          :class="{ chequiado: course.checked }"
                                        >
                                          <img
                                            src="/images/iconos/icon-check.svg"
                                            alt=""
                                          />
                                        </div>
                                        <div class="check-box-text">
                                          <!--img :src="course.iconSrc" alt="" /-->
                                          <p>{{ course.displayName }}</p>
                                          <span
                                            v-tooltip="tooltipMsg[course.name]"
                                            v-if="
                                              course.hasMention &&
                                              !course.displayName
                                                .toLowerCase()
                                                .includes('electivo')
                                            "
                                            class="badge-subject"
                                            :style="{
                                              border: `solid 1px ${course.color}`,
                                              color: course.color,
                                              background: course.fondo,
                                            }"
                                          >
                                            Mención
                                          </span>
                                          <span
                                            v-if="course.common"
                                            class="badge-subject"
                                            :style="{
                                              border: `solid 1px ${course.color}`,
                                              color: course.color,
                                              background: course.fondo,
                                            }"
                                            >Común</span
                                          >
                                          <a href="#" v-if="false"
                                            ><img
                                              src="/images/iconos/help.svg"
                                              alt=""
                                              class="help"
                                          /></a>
                                        </div>
                                      </label>
                                      <label
                                        class="labelWarning"
                                        v-if="course.disabled"
                                      >
                                        No puedes tomar ambos cursos de
                                        {{ course.displayName }}.
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  class="academic-programs pdv-form-group col-12 col-md-6 col-sm-12 col-xs-12"
                                  v-for="course in courses"
                                  v-bind:key="course.id"
                                  v-if="
                                    (course.name === 'Lenguaje' ||
                                      course.name === 'Ciencias Sociales') &&
                                    course.mes === mes_select
                                  "
                                >
                                  <div class="col-md-12">
                                    <div class="custom-checkbox-cont">
                                      <input
                                        @change="disabledMatchCourse(course.id)"
                                        type="checkbox"
                                        v-model="course.checked"
                                        :name="course.name"
                                        :id="course.subject.name + course.id"
                                        class="default"
                                      />
                                      <label
                                        :class="{
                                          'element-disabled': course.disabled,
                                          '': course.checked,
                                        }"
                                        @click="ErrorSubmit = false"
                                        :for="course.subject.name + course.id"
                                        class="checkbox-label"
                                      >
                                        <div
                                          class="pdv-custom-checkbox"
                                          :class="{ chequiado: course.checked }"
                                        >
                                          <img
                                            src="/images/iconos/icon-check.svg"
                                            alt=""
                                          />
                                        </div>
                                        <div class="check-box-text">
                                          <!--img :src="course.iconSrc" alt="" /-->
                                          <p>{{ course.displayName }}</p>
                                          <span
                                            v-tooltip="tooltipMsg[course.name]"
                                            v-if="
                                              course.hasMention &&
                                              !course.displayName
                                                .toLowerCase()
                                                .includes('electivo')
                                            "
                                            class="badge-subject"
                                            :style="{
                                              border: `solid 1px ${course.color}`,
                                              color: course.color,
                                              background: course.fondo,
                                            }"
                                          >
                                            Mención
                                          </span>
                                          <span
                                            v-if="course.common"
                                            class="badge-subject"
                                            :style="{
                                              border: `solid 1px ${course.color}`,
                                              color: course.color,
                                              background: course.fondo,
                                            }"
                                            >Común</span
                                          >
                                          <a href="#" v-if="false"
                                            ><img
                                              src="/images/iconos/help.svg"
                                              alt=""
                                              class="help"
                                          /></a>
                                        </div>
                                      </label>
                                      <label
                                        class="labelWarning"
                                        v-if="course.disabled"
                                      >
                                        No puedes tomar ambos cursos de
                                        {{ course.displayName }}.
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  class="academic-programs pdv-form-group col-12 col-md-6 col-sm-12 col-xs-12"
                                  v-for="course in courses"
                                  v-bind:key="course.id"
                                  v-if="
                                    (course.name === 'Física' ||
                                      course.name === 'Física Mención') &&
                                    course.mes === mes_select
                                  "
                                >
                                  <div class="col-md-12">
                                    <div class="custom-checkbox-cont">
                                      <input
                                        @change="disabledMatchCourse(course.id)"
                                        type="checkbox"
                                        v-model="course.checked"
                                        :name="course.name"
                                        :id="course.subject.name + course.id"
                                        class="default"
                                      />
                                      <label
                                        :class="{
                                          'element-disabled': course.disabled,
                                          '': course.checked,
                                        }"
                                        @click="ErrorSubmit = false"
                                        :for="course.subject.name + course.id"
                                        class="checkbox-label"
                                      >
                                        <div
                                          class="pdv-custom-checkbox"
                                          :class="{ chequiado: course.checked }"
                                        >
                                          <img
                                            src="/images/iconos/icon-check.svg"
                                            alt=""
                                          />
                                        </div>
                                        <div class="check-box-text">
                                          <!--img :src="course.iconSrc" alt="" /-->
                                          <p>{{ course.displayName }}</p>
                                          <span
                                            v-tooltip="tooltipMsg[course.name]"
                                            v-if="course.hasMention"
                                            class="badge-subject"
                                            :style="{
                                              border: `solid 1px ${course.color}`,
                                              color: course.color,
                                              background: course.fondo,
                                            }"
                                            >Mención</span
                                          >
                                          <span
                                            v-if="course.common"
                                            class="badge-subject"
                                            :style="{
                                              border: `solid 1px ${course.color}`,
                                              color: course.color,
                                              background: course.fondo,
                                            }"
                                            >Común</span
                                          >
                                          <a href="#" v-if="false"
                                            ><img
                                              src="/images/iconos/help.svg"
                                              alt=""
                                              class="help"
                                          /></a>
                                        </div>
                                      </label>
                                      <label
                                        class="labelWarning"
                                        v-if="course.disabled"
                                      >
                                        No puedes tomar ambos cursos de
                                        {{ course.displayName }}.
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  class="academic-programs pdv-form-group col-12 col-md-6 col-sm-12 col-xs-12"
                                  v-for="course in courses"
                                  v-bind:key="course.id"
                                  v-if="
                                    (course.name === 'Biología' ||
                                      course.name === 'Biología Mención') &&
                                    course.mes === mes_select
                                  "
                                >
                                  <div class="col-md-12">
                                    <div class="custom-checkbox-cont">
                                      <input
                                        @change="disabledMatchCourse(course.id)"
                                        type="checkbox"
                                        v-model="course.checked"
                                        :name="course.name"
                                        :id="course.subject.name + course.id"
                                        class="default"
                                      />
                                      <label
                                        :class="{
                                          'element-disabled': course.disabled,
                                          '': course.checked,
                                        }"
                                        @click="ErrorSubmit = false"
                                        :for="course.subject.name + course.id"
                                        class="checkbox-label"
                                      >
                                        <div
                                          class="pdv-custom-checkbox"
                                          :class="{ chequiado: course.checked }"
                                        >
                                          <img
                                            src="/images/iconos/icon-check.svg"
                                            alt=""
                                          />
                                        </div>
                                        <div class="check-box-text">
                                          <!--img :src="course.iconSrc" alt="" /-->
                                          <p>{{ course.displayName }}</p>
                                          <span
                                            v-tooltip="tooltipMsg[course.name]"
                                            v-if="course.hasMention"
                                            class="badge-subject"
                                            :style="{
                                              border: `solid 1px ${course.color}`,
                                              color: course.color,
                                              background: course.fondo,
                                            }"
                                            >Mención</span
                                          >
                                          <span
                                            v-if="course.common"
                                            class="badge-subject"
                                            :style="{
                                              border: `solid 1px ${course.color}`,
                                              color: course.color,
                                              background: course.fondo,
                                            }"
                                            >Común</span
                                          >
                                          <a href="#" v-if="false"
                                            ><img
                                              src="/images/iconos/help.svg"
                                              alt=""
                                              class="help"
                                          /></a>
                                        </div>
                                      </label>
                                      <label
                                        class="labelWarning"
                                        v-if="course.disabled"
                                      >
                                        No puedes tomar ambos cursos de
                                        {{ course.displayName }}.
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  class="academic-programs pdv-form-group col-12 col-md-6 col-sm-12 col-xs-12"
                                  v-for="course in courses"
                                  v-bind:key="course.id"
                                  v-if="
                                    (course.name === 'Química' ||
                                      course.name === 'Química Mención') &&
                                    course.mes === mes_select
                                  "
                                >
                                  <div class="col-md-12">
                                    <div class="custom-checkbox-cont">
                                      <input
                                        @change="disabledMatchCourse(course.id)"
                                        type="checkbox"
                                        v-model="course.checked"
                                        :name="course.name"
                                        :id="course.subject.name + course.id"
                                        class="default"
                                      />
                                      <label
                                        :class="{
                                          'element-disabled': course.disabled,
                                          '': course.checked,
                                        }"
                                        @click="ErrorSubmit = false"
                                        :for="course.subject.name + course.id"
                                        class="checkbox-label"
                                      >
                                        <div
                                          class="pdv-custom-checkbox"
                                          :class="{ chequiado: course.checked }"
                                        >
                                          <img
                                            src="/images/iconos/icon-check.svg"
                                            alt=""
                                          />
                                        </div>
                                        <div class="check-box-text">
                                          <!--img :src="course.iconSrc" alt="" /-->
                                          <p>{{ course.displayName }}</p>
                                          <span
                                            v-tooltip="tooltipMsg[course.name]"
                                            v-if="course.hasMention"
                                            class="badge-subject"
                                            :style="{
                                              border: `solid 1px ${course.color}`,
                                              color: course.color,
                                              background: course.fondo,
                                            }"
                                            >Mención</span
                                          >
                                          <span
                                            v-if="course.common"
                                            class="badge-subject"
                                            :style="{
                                              border: `solid 1px ${course.color}`,
                                              color: course.color,
                                              background: course.fondo,
                                            }"
                                            >Común</span
                                          >
                                          <a href="#" v-if="false"
                                            ><img
                                              src="/images/iconos/help.svg"
                                              alt=""
                                              class="help"
                                          /></a>
                                        </div>
                                      </label>
                                      <label
                                        class="labelWarning"
                                        v-if="course.disabled"
                                      >
                                        No puedes tomar ambos cursos de
                                        {{ course.displayName }}.
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="pdv-submit-button mb-4">
                                <div class="d-flex">
                                  <div class="col-md-6">
                                    <div class="form-group position-relative">
                                      <button
                                        type="button"
                                        @click.prevent="saveFormInfo"
                                        :disabled="!courseWasSelected"
                                        class="boton-new-primario boton-new-mediano"
                                      >
                                        ELEGIR HORARIOS
                                      </button>

                                      <div
                                        class="box-error-activator"
                                        @click="ErrorSubmit = true"
                                        :class="{ 'd-none': courseWasSelected }"
                                      ></div>
                                    </div>
                                  </div>

                                  <div
                                    class="col d-flex d-md-block justify-content-md-start justify-content-center"
                                    v-if="ErrorSubmit"
                                  >
                                    <div class="error-message-submit">
                                      <img
                                        src="/images/iconos/icon-alert-red.svg"
                                        alt=""
                                      />
                                      <span
                                        >Aún debes seleccionar los cursos para
                                        tu programa</span
                                      >
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="d-flex mb-4">
                                <div class="col-md-12">
                                  <AcordeonInfo
                                    v-if="
                                      selectedProgram.Metas.programCode !=
                                        'Online I' &&
                                      selectedProgram.Metas.programCode !=
                                        'Online II'
                                    "
                                  />
                                </div>
                              </div>
                            </div>

                            <!-- Cupos Agotados -->
                            <div
                              class="col-md-12"
                              v-if="unavailableSubjects.length"
                            >
                              <div class="disabled-courses-message">
                                <img
                                  src="/images/featured/warning.svg"
                                  alt="warning"
                                />
                                <div>
                                  <p>
                                    Cupos agotados en esta sede para estos
                                    cursos:
                                  </p>
                                  <ul>
                                    <li
                                      :key="idx"
                                      v-for="(
                                        unavailableSubject, idx
                                      ) in unavailableSubjects"
                                    >
                                      {{ unavailableSubject }}
                                    </li>
                                  </ul>
                                  <p>
                                    Puedes buscarlos en otra sede u optar por la
                                    <a class="disabled-courses" href="#"
                                      >modalidad streaming</a
                                    >
                                  </p>
                                </div>
                                <br />
                              </div>
                            </div>

                            <!--Solo sanmiguel -->
                            <div
                              class="col-md-12 custom-aligment"
                              v-if="isSanMiguel && !unavailableSubjects.length"
                            >
                              <!-- <div class="texto-resaltado">
                                <div class="title-note">IMPORTANTE</div>
                                <p class="text-note">
                                  * Solo para la Sede <b>San Miguel</b>, de acuerdo a los
                                  tiempos de habilitación de infraestructura de esta sede,
                                  las clases comenzarán en <b>abril vía streaming</b> y de
                                  <b>forma presencial</b> a más tardar
                                  <b>en junio de 2023</b>
                                </p>
                              </div> -->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- fin Si no es online o PDVX-->

                    <!-- Si es online o PDVX-->
                    <div class="row" v-else>
                      <div class="col-12">
                        <div class="flex">
                          <h4 class="question-form d-flex mb-4">
                            <div class="circulo"><span>1</span></div>
                            Selecciona el mes de inicio de tu programa
                          </h4>
                        </div>

                        <!--div class="col-12 pl-0" v-if="countMounth()">
                          <h4 class="question-form d-flex">
                            <div class="circulo"><span>1</span></div>
                            Selecciona el mes de inicio de tu programa
                          </h4>
                        </div-->

                        <div class="row mb-4" v-if="countMounth()">
                          <b-row class="mb-1">
                            <b-col
                              v-for="(mes, i) in meses_enable"
                              :key="i"
                              cols="12"
                              sm="4"
                              xs="4"
                              class="ml-3 mb-2"
                              v-if="mes.value"
                            >
                              <button
                                class="month-container"
                                @click="handleMounth(i)"
                                :class="mes.addItem ? 'deactive' : 'active'"
                              >
                                <i class="far fa-calendar-alt" />

                                <span>{{ getMounth(i) }}</span>
                              </button>
                            </b-col>
                          </b-row>
                          <div
                            style="width: 100% !important"
                            v-for="(mes, i) in meses_enable"
                            :key="'name' + i"
                          >
                            <div
                              class="col-12 month-start mt-3 mb-2 ml-0"
                              v-if="mes.addItem"
                            >
                              <p class="mb-0">
                                Las clases
                                <span v-if="presente">inician </span>
                                <span v-else>iniciadas </span> el
                                <span>{{ getDate(i) }}</span>
                              </p>
                            </div>
                          </div>
                        </div>

                        <div v-else>
                          <div
                            v-for="(mes, i) in meses_enable"
                            :key="'name' + i"
                            style="width: 100% !important"
                          >
                            <div
                              class="col-12 month-start no-padding"
                              v-if="mes.addItem"
                            >
                              <div
                                class="cards-programs"
                                :class="{ 'border-card': unique == '1' }"
                                @click="changeSelected('1')"
                              >
                                <div class="cards-programs-info">
                                  <img
                                    src="/images/featured/icon-calendar.svg"
                                    class=""
                                    alt="icon-primero"
                                  />
                                  <p>
                                    Las clases
                                    <span v-if="presente">inician </span>
                                    <span v-else>iniciadas</span> el
                                    <span>{{ getDate(i) }} </span>
                                    <span
                                      v-if="one_mes"
                                      style="display: none"
                                      >{{ handleOneMonth(i) }}</span
                                    >
                                  </p>
                                </div>
                                <div class="cards-programs-input">
                                  <input
                                    type="radio"
                                    name="programa"
                                    value="1"
                                    v-model="unique"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="seccion-separator"></div>

                        <div
                          :class="{ 'element-disabled': !selectedLocationInfo }"
                          class="row mb-4"
                        >
                          <div class="col" v-if="mes_select != null">
                            <h4 class="question-form d-flex mb-4">
                              <div class="circulo">
                                {{ countMounth() ? "2" : "2" }}
                              </div>
                              ¿Qué cursos quieres agregar a tu programa?
                            </h4>
                            <div class="row">
                              <div class="col-md-12 no-padding">
                                <div class="row">
                                  <div
                                    class="academic-programs pdv-form-group col-12 col-md-6 col-sm-12 col-xs-12"
                                    v-for="course in courses"
                                    v-bind:key="course.id"
                                    v-if="
                                      (course.name === 'Matemática' ||
                                        course.name ===
                                          'Matemática Electivo') &&
                                      course.mes === mes_select
                                    "
                                  >
                                    <div class="col-md-12">
                                      <div class="custom-checkbox-cont">
                                        <input
                                          @change="
                                            disabledMatchCourse(course.id)
                                          "
                                          type="checkbox"
                                          v-model="course.checked"
                                          :name="course.name"
                                          :id="course.subject.name + course.id"
                                          class="default"
                                        />
                                        <label
                                          :class="{
                                            'element-disabled': course.disabled,
                                            '': course.checked,
                                          }"
                                          @click="ErrorSubmit = false"
                                          :for="course.subject.name + course.id"
                                          class="checkbox-label"
                                        >
                                          <div
                                            class="pdv-custom-checkbox"
                                            :class="{
                                              chequiado: course.checked,
                                            }"
                                          >
                                            <img
                                              src="/images/iconos/icon-check.svg"
                                              alt=""
                                            />
                                          </div>
                                          <div class="check-box-text">
                                            <!--img :src="course.iconSrc" alt="" /-->
                                            <p>{{ course.displayName }}</p>

                                            <span
                                              v-tooltip="
                                                tooltipMsg[course.name]
                                              "
                                              v-if="
                                                course.hasMention &&
                                                !course.displayName
                                                  .toLowerCase()
                                                  .includes('electivo')
                                              "
                                              class="badge-subject"
                                              :style="{
                                                border: `solid 1px ${course.color}`,
                                                color: course.color,
                                                background: course.fondo,
                                              }"
                                            >
                                              Mención
                                            </span>
                                            <span
                                              v-if="course.common"
                                              class="badge-subject"
                                              :style="{
                                                border: `solid 1px ${course.color}`,
                                                color: course.color,
                                                background: course.fondo,
                                              }"
                                              >Común</span
                                            >
                                            <a href="#" v-if="false"
                                              ><img
                                                src="/images/iconos/help.svg"
                                                alt=""
                                                class="help"
                                            /></a>
                                          </div>
                                        </label>
                                        <label
                                          class="labelWarning"
                                          v-if="course.disabled"
                                        >
                                          No puedes tomar ambos cursos de
                                          {{ course.displayName }}.
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="academic-programs pdv-form-group col-12 col-md-6 col-sm-12 col-xs-12"
                                    v-for="course in courses"
                                    v-bind:key="course.id"
                                    v-if="
                                      (course.name === 'Lenguaje' ||
                                        course.name === 'Ciencias Sociales') &&
                                      course.mes === mes_select
                                    "
                                  >
                                    <div class="col-md-12">
                                      <div class="custom-checkbox-cont">
                                        <input
                                          @change="
                                            disabledMatchCourse(course.id)
                                          "
                                          type="checkbox"
                                          v-model="course.checked"
                                          :name="course.name"
                                          :id="course.subject.name + course.id"
                                          class="default"
                                        />
                                        <label
                                          :class="{
                                            'element-disabled': course.disabled,
                                            '': course.checked,
                                          }"
                                          @click="ErrorSubmit = false"
                                          :for="course.subject.name + course.id"
                                          class="checkbox-label"
                                        >
                                          <div
                                            class="pdv-custom-checkbox"
                                            :class="{
                                              chequiado: course.checked,
                                            }"
                                          >
                                            <img
                                              src="/images/iconos/icon-check.svg"
                                              alt=""
                                            />
                                          </div>
                                          <div class="check-box-text">
                                            <!--img :src="course.iconSrc" alt="" /-->
                                            <p>{{ course.displayName }}</p>

                                            <span
                                              v-tooltip="
                                                tooltipMsg[course.name]
                                              "
                                              v-if="
                                                course.hasMention &&
                                                !course.displayName
                                                  .toLowerCase()
                                                  .includes('electivo')
                                              "
                                              class="badge-subject"
                                              :style="{
                                                border: `solid 1px ${course.color}`,
                                                color: course.color,
                                                background: course.fondo,
                                              }"
                                            >
                                              Mención
                                            </span>
                                            <span
                                              v-if="course.common"
                                              class="badge-subject"
                                              :style="{
                                                border: `solid 1px ${course.color}`,
                                                color: course.color,
                                                background: course.fondo,
                                              }"
                                              >Común</span
                                            >
                                            <a href="#" v-if="false"
                                              ><img
                                                src="/images/iconos/help.svg"
                                                alt=""
                                                class="help"
                                            /></a>
                                          </div>
                                        </label>
                                        <label
                                          class="labelWarning"
                                          v-if="course.disabled"
                                        >
                                          No puedes tomar ambos cursos de
                                          {{ course.displayName }}.
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="academic-programs pdv-form-group col-12 col-md-6 col-sm-12 col-xs-12"
                                    v-for="course in courses"
                                    v-bind:key="course.id"
                                    v-if="
                                      (course.name === 'Física' ||
                                        course.name === 'Física Mención') &&
                                      course.mes === mes_select
                                    "
                                  >
                                    <div class="col-md-12">
                                      <div class="custom-checkbox-cont">
                                        <input
                                          @change="
                                            disabledMatchCourse(course.id)
                                          "
                                          type="checkbox"
                                          v-model="course.checked"
                                          :name="course.name"
                                          :id="course.subject.name + course.id"
                                          class="default"
                                        />
                                        <label
                                          :class="{
                                            'element-disabled': course.disabled,
                                            '': course.checked,
                                          }"
                                          @click="ErrorSubmit = false"
                                          :for="course.subject.name + course.id"
                                          class="checkbox-label"
                                        >
                                          <div
                                            class="pdv-custom-checkbox"
                                            :class="{
                                              chequiado: course.checked,
                                            }"
                                          >
                                            <img
                                              src="/images/iconos/icon-check.svg"
                                              alt=""
                                            />
                                          </div>
                                          <div class="check-box-text">
                                            <!--img :src="course.iconSrc" alt="" /-->
                                            <p>{{ course.displayName }}</p>
                                            <span
                                              v-tooltip="
                                                tooltipMsg[course.name]
                                              "
                                              v-if="course.hasMention"
                                              class="badge-subject"
                                              :style="{
                                                border: `solid 1px ${course.color}`,
                                                color: course.color,
                                                background: course.fondo,
                                              }"
                                              >Mención</span
                                            >
                                            <span
                                              v-if="course.common"
                                              class="badge-subject"
                                              :style="{
                                                border: `solid 1px ${course.color}`,
                                                color: course.color,
                                                background: course.fondo,
                                              }"
                                              >Común</span
                                            >
                                            <a href="#" v-if="false"
                                              ><img
                                                src="/images/iconos/help.svg"
                                                alt=""
                                                class="help"
                                            /></a>
                                          </div>
                                        </label>
                                        <label
                                          class="labelWarning"
                                          v-if="course.disabled"
                                        >
                                          No puedes tomar ambos cursos de
                                          {{ course.displayName }}.
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="academic-programs pdv-form-group col-12 col-md-6 col-sm-12 col-xs-12"
                                    v-for="course in courses"
                                    v-bind:key="course.id"
                                    v-if="
                                      (course.name === 'Biología' ||
                                        course.name === 'Biología Mención') &&
                                      course.mes === mes_select
                                    "
                                  >
                                    <div class="col-md-12">
                                      <div class="custom-checkbox-cont">
                                        <input
                                          @change="
                                            disabledMatchCourse(course.id)
                                          "
                                          type="checkbox"
                                          v-model="course.checked"
                                          :name="course.name"
                                          :id="course.subject.name + course.id"
                                          class="default"
                                        />
                                        <label
                                          :class="{
                                            'element-disabled': course.disabled,
                                            '': course.checked,
                                          }"
                                          @click="ErrorSubmit = false"
                                          :for="course.subject.name + course.id"
                                          class="checkbox-label"
                                        >
                                          <div
                                            class="pdv-custom-checkbox"
                                            :class="{
                                              chequiado: course.checked,
                                            }"
                                          >
                                            <img
                                              src="/images/iconos/icon-check.svg"
                                              alt=""
                                            />
                                          </div>
                                          <div class="check-box-text">
                                            <!--img :src="course.iconSrc" alt="" /-->
                                            <p>{{ course.displayName }}</p>
                                            <span
                                              v-tooltip="
                                                tooltipMsg[course.name]
                                              "
                                              v-if="course.hasMention"
                                              class="badge-subject"
                                              :style="{
                                                border: `solid 1px ${course.color}`,
                                                color: course.color,
                                                background: course.fondo,
                                              }"
                                              >Mención</span
                                            >
                                            <span
                                              v-if="course.common"
                                              class="badge-subject"
                                              :style="{
                                                border: `solid 1px ${course.color}`,
                                                color: course.color,
                                                background: course.fondo,
                                              }"
                                              >Común</span
                                            >
                                            <a href="#" v-if="false"
                                              ><img
                                                src="/images/iconos/help.svg"
                                                alt=""
                                                class="help"
                                            /></a>
                                          </div>
                                        </label>
                                        <label
                                          class="labelWarning"
                                          v-if="course.disabled"
                                        >
                                          No puedes tomar ambos cursos de
                                          {{ course.displayName }}.
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="academic-programs pdv-form-group col-12 col-md-6 col-sm-12 col-xs-12"
                                    v-for="course in courses"
                                    v-bind:key="course.id"
                                    v-if="
                                      (course.name === 'Química' ||
                                        course.name === 'Química Mención') &&
                                      course.mes === mes_select
                                    "
                                  >
                                    <div class="col-md-12">
                                      <div class="custom-checkbox-cont">
                                        <input
                                          @change="
                                            disabledMatchCourse(course.id)
                                          "
                                          type="checkbox"
                                          v-model="course.checked"
                                          :name="course.name"
                                          :id="course.subject.name + course.id"
                                          class="default"
                                        />
                                        <label
                                          :class="{
                                            'element-disabled': course.disabled,
                                            '': course.checked,
                                          }"
                                          @click="ErrorSubmit = false"
                                          :for="course.subject.name + course.id"
                                          class="checkbox-label"
                                        >
                                          <div
                                            class="pdv-custom-checkbox"
                                            :class="{
                                              chequiado: course.checked,
                                            }"
                                          >
                                            <img
                                              src="/images/iconos/icon-check.svg"
                                              alt=""
                                            />
                                          </div>
                                          <div class="check-box-text">
                                            <!--img :src="course.iconSrc" alt="" /-->
                                            <p>{{ course.displayName }}</p>
                                            <span
                                              v-tooltip="
                                                tooltipMsg[course.name]
                                              "
                                              v-if="course.hasMention"
                                              class="badge-subject"
                                              :style="{
                                                border: `solid 1px ${course.color}`,
                                                color: course.color,
                                                background: course.fondo,
                                              }"
                                              >Mención</span
                                            >
                                            <span
                                              v-if="course.common"
                                              class="badge-subject"
                                              :style="{
                                                border: `solid 1px ${course.color}`,
                                                color: course.color,
                                                background: course.fondo,
                                              }"
                                              >Común</span
                                            >
                                            <a href="#" v-if="false"
                                              ><img
                                                src="/images/iconos/help.svg"
                                                alt=""
                                                class="help"
                                            /></a>
                                          </div>
                                        </label>
                                        <label
                                          class="labelWarning"
                                          v-if="course.disabled"
                                        >
                                          No puedes tomar ambos cursos de
                                          {{ course.displayName }}.
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="pdv-submit-button mb-4">
                                  <div class="d-flex">
                                    <div class="col-md-6">
                                      <div class="form-group position-relative">
                                        <button
                                          type="button"
                                          @click.prevent="saveFormInfo"
                                          :disabled="!courseWasSelected"
                                          class="boton-new-primario boton-new-mediano"
                                        >
                                          ELEGIR HORARIOS
                                        </button>
                                        <div
                                          class="box-error-activator"
                                          @click="ErrorSubmit = true"
                                          :class="{
                                            'd-none': courseWasSelected,
                                          }"
                                        ></div>
                                      </div>
                                    </div>

                                    <div
                                      class="col d-flex d-md-block justify-content-md-start justify-content-center"
                                      v-if="ErrorSubmit"
                                    >
                                      <div class="error-message-submit">
                                        <img
                                          src="/images/iconos/icon-alert-red.svg"
                                          alt=""
                                        />
                                        <span
                                          >Aún debes seleccionar los cursos para
                                          tu programa</span
                                        >
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="row">
                              <div class="col-md-12">
                                <AcordeonInfo
                                  v-if="
                                    selectedProgram.Metas.programCode !=
                                      'Online I' &&
                                    selectedProgram.Metas.programCode !=
                                      'Online II'
                                  "
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- fin Si es online o PDVX-->
                  </div>
                  <!-- pdv-form-group-->
                </div>
              </div>
              <!-- fin col-7-->

              <div class="item">
                <img
                  src="/images/featured/gorl-imagin-book-idea.svg"
                  alt="gorl-imagin-book-idea"
                  class="imagen-pensar"
                  v-if="!selectedLocationInfo"
                />

                <div class="fija">
                  <div
                    v-if="selectedLocationInfo"
                    class="row"
                    v-inview:class="['animated', 'fadeIn']"
                  >
                    <div class="col">
                      <div>
                        <div class="address-item">
                          <div class="d-flex flex-col justify-content-center">
                            <!--img
                              src="/images/iconos/Flecha-derecha.svg"
                              alt=""
                            /-->
                            <h5 class="nombre-sede-small">Sede</h5>
                            <h3 class="nombre-sede">
                              {{ selectedLocationInfo.name }}
                            </h3>
                          </div>
                          <ul v-if="showLocationsAndCourses">
                            <li>
                              <!--span
                                ><img
                                  src="/images/iconos/location.svg"
                                  alt=""
                              /></span-->
                              <p>{{ selectedLocationInfo.address }}</p>
                            </li>
                            <li>
                              <!--span
                                ><img src="/images/iconos/clock.svg" alt=""
                              /></span-->
                              <p>
                                Lunes a Viernes de 9 a 20hs. Sábados de 9 a
                                14hs.
                              </p>
                            </li>
                            <li v-if="selectedLocationInfo.phone">
                              <!--span
                                ><img src="/images/iconos/tel.svg" alt=""
                              /></span-->
                              <p>{{ selectedLocationInfo.phone }}</p>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="selectedLocationInfo && showLocationsAndCourses">
                    <div class="map-container">
                      <!-- <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14746.586520600613!2d-68.93621302848258!3d-22.479909736395246!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x96ac0835aed8e935%3A0xe17c2575c5851f04!2sAv.+Libertador+Bernardo+O&#39;Higgins%2C+Calama%2C+Regi%C3%B3n+de+Antofagasta%2C+Chile!5e0!3m2!1ses!2sco!4v1556506720077!5m2!1ses!2sco" width="100%" height="100%" frameborder="0" style="border:0" allowfullscreen></iframe> -->

                      <!-- src="https://maps.google.com/maps?q=Heroes%20de%20la%20Concepci%C3%B3n%20%232555%2C%20Iquique%2C%20Chile&t=&z=15&ie=UTF8&iwloc=&output=embed"  -->

                      <!-- :src="getGmapsEmbedURL"  -->
                      <div class="mapouter">
                        <div class="gmap_canvas">
                          <iframe
                            v-if="gmapsEmbedURL"
                            width="100%"
                            height="280"
                            id="gmap_canvas"
                            :src="gmapsEmbedURL"
                            frameborder="0"
                            scrolling="no"
                            marginheight="0"
                            marginwidth="0"
                          >
                          </iframe>
                        </div>
                      </div>
                      <!-- process.env.VUE_APP_GMAPS_KEY -->
                    </div>
                  </div>

                  <div v-else class="d-flex flex-column">
                    <div
                      v-if="!showLocationsAndCourses"
                      class="col-md-12 d-flex justify-content-center"
                    >
                      <img
                        class="pdvxImg"
                        src="/images/featured/gorl-imagin-book-idea.svg"
                        v-if="
                          selectedProgram.Metas.programCode != 'Online I' &&
                          selectedProgram.Metas.programCode != 'Online II'
                        "
                      />
                      <div
                        class="d-flex flex-column desc-collapse mb-4"
                        v-if="
                          selectedProgram.Metas.programCode == 'Online I' ||
                          selectedProgram.Metas.programCode == 'Online II'
                        "
                      >
                        <h4 class="h4-header-title mb-4 black">IMPORTANTE</h4>
                        <p class="initial-text s-b">
                          Debe seleccionar un mínimo de 3 cursos para contratar
                          el programa (Ej: LE, MA y QC).
                        </p>
                        <p class="initial-text s-b">
                          Si selecciona menos de 3 cursos, NO podrá avanzar en
                          la compra.
                        </p>
                      </div>
                    </div>
                    <div class="ml-4 mt-5">
                      <div
                        v-if="selectedLocationInfo"
                        class="row"
                        v-inview:class="['animated', 'fadeIn']"
                      >
                        <div class="col">
                          <div>
                            <div class="address-item">
                              <div class="d-flex align-items-center mb-4">
                                <img
                                  src="/images/iconos/Flecha-derecha.svg"
                                  alt=""
                                />
                                <h3
                                  v-if="!showLocationsAndCourses"
                                  class="nombre-sede"
                                >
                                  {{
                                    selectedLocationInfo.name
                                      .replace("Pre", "")
                                      .replace("Virtual", "PDVx")
                                      .replace("universitario", "")
                                  }}
                                </h3>
                                <h3 v-else class="nombre-sede">
                                  SEDE {{ selectedLocationInfo.name }}
                                </h3>
                              </div>
                              <ul v-if="showLocationsAndCourses">
                                <li>
                                  <span
                                    ><img
                                      src="/images/iconos/location.svg"
                                      alt=""
                                  /></span>
                                  <p>{{ selectedLocationInfo.address }}</p>
                                </li>
                                <li>
                                  <span
                                    ><img src="/images/iconos/clock.svg" alt=""
                                  /></span>
                                  <p>
                                    Lunes a Viernes de 9 a 20hs. Sábados de 9 a
                                    14hs.
                                  </p>
                                </li>
                                <li v-if="selectedLocationInfo.phone">
                                  <span
                                    ><img src="/images/iconos/tel.svg" alt=""
                                  /></span>
                                  <p>{{ selectedLocationInfo.phone }}</p>
                                </li>
                              </ul>
                              <ul
                                class="custom-list"
                                v-else-if="selectedProgram.isOnline"
                              >
                                <li>
                                  <p>
                                    Programa de clases virtuales en una amigable
                                    plataforma para preparar la prueba de
                                    transición y subir tu puntaje
                                  </p>
                                </li>
                                <li>
                                  <p>
                                    Permite organizar tus tiempos y estudiar
                                    desde donde más te acomode
                                  </p>
                                </li>
                                <li>
                                  <p>
                                    Considera clases, apoyos como talleres,
                                    orientación, tutores y más.
                                  </p>
                                </li>
                                <li>
                                  <p>
                                    Cuenta con diversos recursos para aprender
                                    los contenidos, ejercitarlos y evaluar tu
                                    progreso.
                                  </p>
                                </li>
                                <li>
                                  <p>Logra tu máximo.</p>
                                </li>
                              </ul>
                              <ul class="custom-list" v-else>
                                <li>
                                  <p>
                                    Programa vía streaming en vivo para preparar
                                    la PAES y subir tu puntaje.
                                  </p>
                                </li>
                                <li>
                                  <p>
                                    Permite organizar tus tiempos y estudiar
                                    desde donde más te acomode
                                  </p>
                                </li>
                                <li>
                                  <p>
                                    Considera clases, apoyos como talleres,
                                    orientación, tutores y más; todo vía
                                    Streaming en vivo.
                                  </p>
                                </li>
                                <li>
                                  <p>
                                    Cuenta con amigables plataformas para
                                    aprender los contenidos, ejercitarlos y
                                    evaluar tu progreso.
                                  </p>
                                </li>
                                <li>
                                  <p>Logra tu máximo.</p>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- fin col-5-->
            </div>
          </div>
          <!-- fin custon padding-->
        </div>
        <!-- fin pdv container-->
      </div>
    </div>

    <InfoModal
      title="¡Matricula todos los cursos por el precio de 1!"
      despcription="Selecciona los 6 cursos permitidos y obtén nuestro pack completo."
    />

    <a
      style="visibility: hidden"
      ref="btnSuccessfulFlowModal"
      data-backdrop="static"
      data-keyboard="false"
      href=".info-flow-modal"
      data-toggle="modal"
    ></a>
  </layout-default>
</template>

<script>
import LayoutDefault from "@/layouts/Default";
import formValidation from "@/mixins/formValidation";
import selectedSubjectAndCourses from "@/mixins/selectedSubjectAndCourses";
import localPageTimerMixin from "@/mixins/localPageTimerMixin";
import StepsHeader from "@/components/StepsHeader";
import InfoModal from "@/components/modals/InfoModal";
import moment from "moment";
import "moment/locale/es"; // without this line it didn't work
import Multiselect from "vue-multiselect";
import Button from "@/components/featured/Button";
import AcordeonInfo from "@/components/AcordeonInfo";
moment.locale("es");
export default {
  components: {
    LayoutDefault,
    StepsHeader,
    Multiselect,
    InfoModal,
    Button,
    AcordeonInfo,
  },
  data() {
    return {
      openCollapse: false,
      txtString:
        "En la prueba de Ciencias Naturales se te preguntará materia de Física, Química y Biología. Es obligación que escojas uno de estos ramos como tu ciencia mención, del cual se te preguntará una mayor cantidad de contenidos, ya que más del 50% de las preguntas de la prueba estarán relacionadas a dicha materia. Al tomar la ciencia mención no es necesario tomar la misma ciencia en común, ya que la mención incluye la totalidad de los contenidos de dicho ramo. Los dos ramos restantes corresponden a las ciencias comunes, de los cuales tendrás que responder una menor cantidad de preguntas. Ejemplo: Biología mención + Física común + Química común ¡Recuerda! Puedes rendir la mención que tu desees, independiente de la carrera que quieras estudiar",
      one_mes: true,
      mes_select: null,
      meses_enable: [],
      mesesGeneral: [],
      loading: false,
      year: 2025,
      hoy: moment(new Date()).format("YYYY-MM-DD"),
      presente: false,
      animatedPulse: false,
      selectedCommune: null,
      selectedLocation: null,
      availableCities: [],
      availableLocations: [],
      serverLocations: [],
      availableCourses: [],
      gmapsEmbedURL: null,
      inputSearchComponentKey: 0,
      tooltipMsg: {
        ["Física"]:
          "Si piensas dar la prueba de Ciencias y Física es tu fuerte",
        ["Química"]:
          "Si piensas dar la prueba de Ciencias y Química es tu fuerte",
        ["Biología"]:
          "Si piensas dar la prueba de Ciencias y Biología es tu fuerte",

        ["Física Mención"]:
          "Si piensas dar la prueba de Ciencias y Física es tu fuerte",
        ["Química Mención"]:
          "Si piensas dar la prueba de Ciencias y Química es tu fuerte",
        ["Biología Mención"]:
          "Si piensas dar la prueba de Ciencias y Biología es tu fuerte",
        ["Matemática Electivo"]:
          "Si quieres estudiar en una carrera ligada a las Ciencias, Tecnología, Ingeniería o Matemáticas",
      },
      unique: "1",
    };
  },
  computed: {
    lastStudent() {
      return this.$store.getters.lastStudent;
    },
    courseWasSelected() {
      let programsChecked = this.courses.filter((course) => course.checked);
      return programsChecked.length > 0;
    },
    selectedLocationInfo() {
      return this.availableLocations.find((location) => {
        return location.id === this.selectedLocation;
      });
    },
    selectedProgram() {
      return this.$store.state.selectedProgram;
    },

    showLocationsAndCourses() {
      return (
        !this.$store.state.selectedProgram.isPdvX &&
        !this.$store.state.selectedProgram.isOnline
      );
    },
    selectedCourses() {
      let selectedCourses = this.courses.filter((course) => course.checked);
      return selectedCourses;
    },
    locationPdvOnline() {
      return process.env.VUE_APP_LOCATION_ONLINE;
    },
    isSanMiguel() {
      if (!this.selectedLocation) {
        return false;
      } else {
        const filter = this.availableLocations.find(
          (l) => l.id === this.selectedLocation
        );
        return filter.name.includes("San Miguel");
      }
    },
  },

  watch: {
    availableLocations(newVal) {
      if (newVal.length === 1) {
        this.selectedLocation = newVal[0].id;
        this.coursesHandler();
      }
    },
  },

  mixins: [selectedSubjectAndCourses, formValidation, localPageTimerMixin],
  methods: {
    setCommuneAndLocationFromStore() {
      if (
        !this.selectedProgram.isOnline &&
        !this.selectedProgram.isPdvX &&
        this.lastStudent &&
        this.lastStudent.preferredVenue
      ) {
        const selectedComune = this.availableCities.find(
          (city) => city.id === this.lastStudent.preferredVenue.communeId
        );
        this.onSelectLocation(selectedComune);
        this.selectedLocation = this.lastStudent.preferredVenue.id;
      }
    },
    isSame(str1, str2) {
      return moment(str1).isSame(str2);
    },
    isLater(str1, str2) {
      return moment(str1).isAfter(str2);
    },
    /* change(showAll) {
      console.log(showAll);
    }, */
    disabledMatchCourse(id) {
      var curso = this.courses.find((course) => course.id === id);
      const disable = (param) => {
        if (
          this.courses.find(
            (c) => c.id != id && c.displayName === curso.displayName
          )
        ) {
          let match = this.courses.find(
            (c) => c.id != id && c.displayName === curso.displayName
          );
          let m = this.courses.find((c) => c.id === match.id);
          this.courses.map((c) => {
            if (c.id === m.id) {
              c.disabled = param;
            }
          });
        }
      };
      disable(curso.checked);
      if (curso.displayName === "Matemática Electivo (M2)" && curso.checked) {
        let cursoFindIndex;
        this.courses.forEach((course, index) => {
          if (course.displayName === "Matemática (M1)") {
            cursoFindIndex = index;
          }
        });
        this.courses[cursoFindIndex].checked = true;
        disable(this.courses[cursoFindIndex].checked);
      }
      if (curso.seatsAvailable <= 2) {
        let matematicaIndex;
        this.courses.forEach((course, index) => {
          if (course.displayName === "Matemática") {
            matematicaIndex = index;
          }
        });
        if (typeof matematicaIndex !== "undefined") {
          this.courses[matematicaIndex].checked = false;
          disable(this.courses[matematicaIndex].checked);
        }
        // this.courses[matematicaIndex].checked = false;
        // disable(this.courses[matematicaIndex].checked);
      }
      if (curso.displayName === "Matemática (M1)" && !curso.checked) {
        let cursoFindIndex;
        this.courses.forEach((course, index) => {
          if (course.displayName === "Matemática Electivo (M2)") {
            cursoFindIndex = index;
          }
        });
        if (typeof cursoFindIndex !== "undefined") {
          this.courses[cursoFindIndex].checked = false;
          disable(this.courses[cursoFindIndex].checked);
        }
      }
    },
    updateGmapsEmbedURL() {
      let queryString = `${this.selectedLocationInfo.address.split(",")[0]},${
        this.selectedLocationInfo.City.name
      },Chile`;

      this.gmapsEmbedURL = `https://maps.google.com/maps?q=${queryString}&t=&z=15&ie=UTF8&iwloc=&output=embed`;
    },
    saveFormInfo() {
      this.$store.dispatch("clearSelectedSubjects").then(() => {
        this.$store.dispatch("clearSubjectsWithCourses");
        let promesas = [];
        this.selectedCourses.forEach((subject) => {
          promesas.push(
            new Promise((resolve) => {
              let coursesBelongsToSelectedSubject = this.coursesFromApi.filter(
                (course) => {
                  return (
                    course.Subject.id === subject.id &&
                    course.mes === this.mes_select
                  );
                }
              );

              let subjectAndCourses = {
                ...subject,
                courses: coursesBelongsToSelectedSubject,
              };

              this.$store.dispatch("addSubject", subjectAndCourses);
              this.$store.dispatch("addSubjectWithCourses", subjectAndCourses);
              resolve();
            })
          );
        });

        Promise.all(promesas).then(() => {
          this.$store
            .dispatch("saveSelectedLocation", this.selectedLocationInfo)
            .then(() => {
              let step = "Step2";
              if (this.selectedProgram.isOnline) {
                step = "Step3";
              }
              this.goToNextStep(step);
            });
        });
      });
    },

    goToNextStep(step) {
      this.$router.push({ name: step });
    },

    clearForm() {
      this.selectedCommune = null;
      this.selectedLocation = null;
    },
    onSelectLocation(data) {
      this.selectedCommune = data;
      if (this.selectedCommune) {
        this.availableLocations = this.serverLocations.filter((item) => {
          return item.Commune.id === this.selectedCommune.id;
        });
      } else {
        this.availableLocations = this.data;
      }
    },
    locationsHandler(event) {
      this.selectedCommune = event.id;
      if (this.selectedCommune) {
        this.availableLocations = this.serverLocations.filter((location) => {
          return location.Commune.id === this.selectedCommune;
        });
      } else {
        this.availableLocations = this.serverLocations;
      }
    },

    async coursesHandler() {
      if (this.showLocationsAndCourses) {
        this.updateGmapsEmbedURL();
      }
      this.one_mes = true;
      /* const { data } = await this.Axios.get(
        `/courses?programId=${this.selectedProgram.id}&locationId=${this.selectedLocation}&mes=${this.meses_enable}`
      ); */
      //this.coursesFromApi = data;
      //this.refactorCourses();
    },

    refactorCourses() {
      let coursesSubjects = this.coursesFromApi.map((course) => {
        course = {
          id: course.Subject.id,
          name: course.Subject.name,
          subject: course.Subject,
          hasMention: course.hasMention,
          disabled: false,
          mes: course.mes,
        };

        this.$set(course, "checked", false);

        if (course.subject.name === "Lenguaje") {
          course.iconSrc = "/images/iconos/languaje.svg";
          course.color = "#135FAB";
          course.fondo = "#C8E3FD";
          this.$set(course, "displayName", "Lenguaje");
        } else if (course.subject.name === "Química") {
          course.iconSrc = "/images/iconos/quimica.svg";
          course.color = "#652467";
          course.fondo = "#F7EAFA";
          course.common = true;
          this.$set(course, "displayName", "Química");
        } else if (course.subject.name === "Matemática") {
          course.iconSrc = "/images/iconos/maths.svg";
          course.color = "#E6352B";
          course.fondo = "#FDC3C4";
          this.$set(course, "displayName", "Matemática (M1)");
        } else if (course.subject.name === "Física") {
          course.iconSrc = "/images/iconos/fisica.svg";
          course.color = "#A1BC2D";
          course.fondo = "#e0f589";
          course.common = true;
          this.$set(course, "displayName", "Física");
        } else if (course.subject.name === "Ciencias Sociales") {
          course.iconSrc = "/images/iconos/sociales.svg";
          course.color = "#ED7820";
          course.fondo = "#FDE6B9";
          this.$set(course, "displayName", "Ciencias Sociales");
        } else if (course.subject.name === "Biología") {
          course.iconSrc = "/images/iconos/biologia.svg";
          course.color = "#118A3F";
          course.fondo = "#C8FDE3";
          course.common = true;
          this.$set(course, "displayName", "Biología");
        } else if (course.subject.name === "Ciencias Sociales Mención") {
          course.iconSrc = "/images/iconos/sociales.svg";
          course.color = "#ED7820";
          course.fondo = "#FDE6B9";
          this.$set(course, "displayName", "Ciencias Sociales");
        } else if (course.subject.name === "Biología Mención") {
          course.iconSrc = "/images/iconos/biologia.svg";
          course.color = "#118A3F";
          course.fondo = "#C8FDE3";
          this.$set(course, "displayName", "Biología");
        } else if (course.subject.name === "Física Mención") {
          course.iconSrc = "/images/iconos/fisica.svg";
          course.color = "#A1BC2D";
          course.fondo = "#e0f589";
          this.$set(course, "displayName", "Física");
        } else if (course.subject.name === "Lenguaje Mención") {
          course.iconSrc = "/images/iconos/languaje.svg";
          course.color = "#C8E3FD";
          this.$set(course, "displayName", "Lenguaje");
        } else if (course.subject.name === "Matemática Mención") {
          course.iconSrc = "/images/iconos/maths.svg";
          course.color = "#E6352B";
          course.fondo = "#FDC3C4";
          this.$set(course, "displayName", "Matemática Electivo (M2)");
        } else if (course.subject.name === "Matemática Electivo") {
          course.iconSrc = "/images/iconos/maths.svg";
          course.color = "#E6352B";
          course.fondo = "#FDC3C4";
          this.$set(course, "displayName", "Matemática Electivo (M2)");
        } else if (course.subject.name === "Química Mención") {
          course.iconSrc = "/images/iconos/quimica.svg";
          course.color = "#652467";
          course.fondo = "#F7EAFA";
          this.$set(course, "displayName", "Química");
        } else {
          course.iconSrc = "/images/iconos/fisica.svg";
          course.color = "#A1BC2D";
          course.fondo = "#FDC3C4";
          this.$set(course, "displayName", "Undefined");
        }

        return course;
      });

      this.courses = [];
      coursesSubjects.reverse().forEach((course) => {
        let itemInArray = this.courses.find(
          (item) => item.name === course.name
        );
        if (!itemInArray) {
          this.courses.push(course);
        }
      });

      this.courses.sort((a, b) => {
        let name1 = a.name;
        let name2 = b.name;
        return this.subjectsOrder[name1] - this.subjectsOrder[name2];
      });

      let availableSubjectsNames = [];
      this.courses.forEach((course) => {
        let itemInArray = availableSubjectsNames.find(
          (subject) => subject === course.name
        );
        if (!itemInArray) {
          availableSubjectsNames.push(course.name);
        }
      });

      this.unavailableSubjects = this.allSubjects.filter((subject) => {
        return !availableSubjectsNames.includes(subject);
      });
    },

    async handleMounth(i) {
      if (!this.meses_enable[i].addItem) {
        for (let x = 0; x <= 11; x++) {
          if (x != i) {
            this.meses_enable[x].addItem = false;
          } else {
            this.meses_enable[i].addItem = true;
            this.mes_select = String(i + 1);
          }
        }
      } else {
        this.meses_enable[i].addItem = false;
      }

      const { data } = await this.Axios.get(
        `/courses/findbymes/programId?programId=${
          this.selectedProgram.id
        }&locationId=${this.selectedLocation}&mes=${i + 1}`
      );
      this.coursesFromApi = data;
      this.refactorCourses();
      if (
        this.isLater(
          moment(this.mesesGeneral[i]).format("YYYY-MM-DD"),
          this.hoy
        ) ||
        this.isSame(moment(this.mesesGeneral[i]).format("YYYY-MM-DD"), this.hoy)
      ) {
        this.presente = true;
      } else {
        this.presente = false;
      }
    },
    getMounth(index) {
      return moment(this.mesesGeneral[index]).format("MMMM YYYY");
    },

    getDate(index) {
      //console.log(this.mesesGeneral[index])
      return (
        moment(this.mesesGeneral[index]).format("D") +
        " de " +
        moment(this.mesesGeneral[index]).format("MMMM")
      );
    },

    countMounth() {
      let count = this.meses_enable.filter((mes) => mes.value == true);

      return count.length > 1;
    },
    async handleOneMonth(i) {
      const { data } = await this.Axios.get(
        `/courses/findbymes/programId?programId=${
          this.selectedProgram.id
        }&locationId=${this.selectedLocation}&mes=${i + 1}`
      );
      this.one_mes = false;
      this.coursesFromApi = data;
      this.refactorCourses();
      if (
        this.isLater(
          moment(this.mesesGeneral[i]).format("YYYY-MM-DD"),
          this.hoy
        ) ||
        this.isSame(moment(this.mesesGeneral[i]).format("YYYY-MM-DD"), this.hoy)
      ) {
        this.presente = true;
      } else {
        this.presente = false;
      }
    },
  },

  created() {
    let coursesSubjects = this.coursesFromApi.map((course) => {
      course = {
        id: course.subject.id,
        name: course.subject.name,
        subject: course.subject,
        hasMention: !!course.hasMention,
        disabled: false,
      };

      this.$set(course, "checked", false);

      if (course.subject.name === "Lenguaje") {
        course.iconSrc = "/images/iconos/languaje.svg";
        course.color = "#135FAB";
        course.fondo = "#C8E3FD";
        this.$set(course, "displayName", "Lenguaje");
      } else if (course.subject.name === "Química") {
        course.iconSrc = "/images/iconos/quimica.svg";
        course.color = "#652467";
        course.fondo = "#F7EAFA";
        course.common = true;
        this.$set(course, "displayName", "Química");
      } else if (course.subject.name === "Matemática") {
        course.iconSrc = "/images/iconos/maths.svg";
        course.color = "#E6352B";
        course.fondo = "#FDC3C4";
        this.$set(course, "displayName", "Matemática");
      } else if (course.subject.name === "Física") {
        course.iconSrc = "/images/iconos/fisica.svg";
        course.color = "#A1BC2D";
        course.fondo = "#e0f589";
        course.common = true;
        this.$set(course, "displayName", "Física");
      } else if (course.subject.name === "Ciencias Sociales") {
        course.iconSrc = "/images/iconos/sociales.svg";
        course.color = "#ED7820";
        course.fondo = "#FDE6B9";
        this.$set(course, "displayName", "Ciencias Sociales");
      } else if (course.subject.name === "Biología") {
        course.iconSrc = "/images/iconos/biologia.svg";
        course.color = "#118A3F";
        course.fondo = "#C8FDE3";
        course.common = true;
        this.$set(course, "displayName", "Biología");
      } else if (course.subject.name === "Ciencias Sociales Mención") {
        course.iconSrc = "/images/iconos/sociales.svg";
        course.color = "#ED7820";
        course.fondo = "#FDE6B9";
        this.$set(course, "displayName", "Ciencias Sociales");
      } else if (course.subject.name === "Biología Mención") {
        course.iconSrc = "/images/iconos/biologia.svg";
        course.color = "#118A3F";
        course.faondo = "#C8FDE3";
        this.$set(course, "displayName", "Biología");
      } else if (course.subject.name === "Física Mención") {
        course.iconSrc = "/images/iconos/fisica.svg";
        course.color = "#A1BC2D";
        course.fondo = "#e0f589";
        this.$set(course, "displayName", "Física");
      } else if (course.subject.name === "Lenguaje Mención") {
        course.iconSrc = "/images/iconos/languaje.svg";
        course.color = "#135FAB";
        course.fondo = "#C8E3FD";
        this.$set(course, "displayName", "Lenguaje");
      } else if (course.subject.name === "Matemática Mención") {
        course.iconSrc = "/images/iconos/maths.svg";
        course.color = "#E6352B";
        course.fondo = "#FDC3C4";
        this.$set(course, "displayName", "Matemática Electivo");
      } else if (course.subject.name === "Matemática Electivo") {
        course.iconSrc = "/images/iconos/maths.svg";
        course.color = "#E6352B";
        course.fondo = "#FDC3C4";
        this.$set(course, "displayName", "Matemática Electivo");
      } else if (course.subject.name === "Química Mención") {
        course.iconSrc = "/images/iconos/quimica.svg";
        course.color = "#652467";
        course.fondo = "#F7EAFA";
        this.$set(course, "displayName", "Química");
      } else {
        course.iconSrc = "/images/iconos/fisica.svg";
        course.color = "#135FAB";
        course.fondo = "#e0f589";
        this.$set(course, "displayName", "Undefined");
      }

      return course;
    });

    coursesSubjects.forEach((course) => {
      let itemInArray = this.courses.find((item) => item.name === course.name);
      if (!itemInArray) {
        this.courses.push(course);
      }
    });
  },

  async mounted() {
    let response = await this.Axios.get(
      `/locations${!this.showLocationsAndCourses ? "?pdvX=true" : ""}`
    );
    this.availableLocations = response.data;
    this.serverLocations = response.data;
    let locations = this.availableLocations.map((location) => {
      return location.Commune;
    });
    locations.forEach((location) => {
      let itemInArray = this.availableCities.find(
        (item) => item.id === location.id
      );
      if (!itemInArray) {
        this.availableCities.push(location);
      }
    });

    this.availableCities.sort((a, b) => {
      a = a.name.toLowerCase();
      b = b.name.toLowerCase();

      if (a > b) {
        return 1;
      } else if (a < b) {
        return -1;
      }
      return 0;
    });

    this.setCommuneAndLocationFromStore();

    if (this.selectedProgram.isOnline) {
      this.$refs.btnSuccessfulFlowModal.click();
      const { data } = await this.Axios.get(
        `/findLocationsPdvId/${this.locationPdvOnline}`
      );
      this.selectedLocation = data.id;
      this.coursesHandler();
    } else if (this.selectedProgram.isPdvX) {
      const { data } = await this.Axios.get(
        `/locations/${this.selectedProgram.Locations[0].id}`
      );
      this.selectedLocation = data.id;
      this.coursesHandler();
    }

    window.$(".pdv-custom-select").select2({
      width: "100%",
      placeholder: "Seleccione una sede",
      sorter: function (data) {
        /* Sort data using lowercase comparison */
        return data.sort(function (a, b) {
          a = a.text.toLowerCase();
          b = b.text.toLowerCase();
          if (a > b) {
            return 1;
          } else if (a < b) {
            return -1;
          }
          return 0;
        });
      },
    });

    this.loading = true;
    let { data: mesesGeneral } = await this.Axios.get(
      "/datesprograms/" + this.year
    );

    for (let i = 0; i < mesesGeneral.length; i++) {
      if (mesesGeneral[i].id == this.year) {
        this.mesesGeneral[0] = mesesGeneral[i].enero;

        this.mesesGeneral[1] = mesesGeneral[i].febrero;
        this.mesesGeneral[2] = mesesGeneral[i].marzo;
        this.mesesGeneral[3] = mesesGeneral[i].abril;
        this.mesesGeneral[4] = mesesGeneral[i].mayo;
        this.mesesGeneral[5] = mesesGeneral[i].junio;
        this.mesesGeneral[6] = mesesGeneral[i].julio;
        this.mesesGeneral[7] = mesesGeneral[i].agosto;
        this.mesesGeneral[8] = mesesGeneral[i].septiembre;
        this.mesesGeneral[9] = mesesGeneral[i].octubre;
        this.mesesGeneral[10] = mesesGeneral[i].noviembre;
        this.mesesGeneral[11] = mesesGeneral[i].diciembre;
      }
    }

    let meses_array = [];

    let meses_enable = JSON.parse(
      JSON.parse(this.$store.state.selectedProgram.Metas.meses_enable).meses
    );
    //console.log(meses_enable);
    let countMounths = 0;
    for (let i = 0; i <= 11; i++) {
      if (
        meses_enable[i].value === true &&
        JSON.parse(mesesGeneral[0].enable)[i].value === true
      ) {
        meses_array.push({ addItem: false, value: true });
        countMounths++;
      } else {
        meses_array.push({ addItem: false, value: false });
      }
    }

    if (countMounths > 1) {
      this.meses_enable = meses_array;
    } else {
      for (let i = 0; i <= 11; i++) {
        if (meses_array[i].value) {
          meses_array[i] = { addItem: true, value: true };
          this.mes_select = String(i + 1);
        }
      }
      this.meses_enable = meses_array;
    }
    this.loading = false;
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">
.imagen-pensar {
  @media (min-width: 769px) {
    margin-top: -170px;
  }
}

.div-alinear {
  display: flex;
  gap: 40px;
  @media (max-width: 768px) {
    flex-direction: column;
  }
  @media (min-width: 769px) {
    flex-direction: row;
  }
  .item {
    @media (max-width: 768px) {
      width: 100%;
    }
    @media (min-width: 769px) {
      width: 50%;
    }
  }
}

.seccion-separator {
  width: 100%;
  @media (max-width: 768px) {
    margin-top: 32px;
  }
  @media (min-width: 769px) {
    margin-top: 40px;
  }
}

.no-padding {
  padding: 0;
}

.boton-new-primario {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background-color: $morado50;
  border: solid 4px $neutralwhite;
  color: $neutralwhite;
  &:hover {
    background-color: $morado30;
  }
  &:active {
    background-color: $morado90;
  }
  &:focus {
    background-color: $morado50;
    border: solid 4px grey;
  }
  &:disabled {
    background-color: #5924661a;
  }

  &.boton-new-largo {
    padding: 0 32px;
    height: 60px;
    width: auto;
    font-size: 20px;
    line-height: 28px;
  }
  &.boton-new-mediano {
    padding: 0 24px;
    height: 48px;
    width: auto;
    font-size: 16px;
    line-height: 18px;
  }
  &.boton-new-pequeno {
    padding: 0 16px;
    height: 32px;
    width: auto;
    font-size: 14px;
    line-height: 22px;
  }

  img {
    margin-right: 16px;
  }
}

.cards-programs {
  background: $neutral05;
  border: solid 2px $colorTerciarioSuave;
  height: 72px;
  border-radius: 8px 24px 8px 8px;
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;

  @media (max-width: 768px) {
    width: 100%;
  }
  @media (min-width: 769px) {
    width: 400px;
  }

  .cards-programs-info {
    display: flex;
    align-items: center;
    height: 100%;
    gap: 12px;

    p {
      margin-bottom: 0 !important;
      color: $neutralBlack !important;
      font-family: "Poppins-Medium", sans-serif !important;
      font-size: 16px !important;
      line-height: 24px !important;
      span {
        margin-bottom: 0 !important;
        color: $neutralBlack !important;
        font-family: "Poppins-Medium", sans-serif !important;
        font-size: 16px !important;
        line-height: 24px !important;
      }
    }
  }
  .cards-programs-input {
    display: flex;
    align-items: center;
    height: 100%;
  }

  input[type="radio"] {
    appearance: none;
    background-color: $neutral05;
    margin: 0;
    font: inherit;
    color: currentColor;
    width: 1.25em;
    height: 1.25em;
    border: 0.15em solid currentColor;
    border-radius: 50%;
    transform: translateY(-0.075em);
    display: grid;
    place-content: center;
  }

  input[type="radio"]::before {
    content: "";
    width: 0.65em;
    height: 0.65em;
    border-radius: 50%;
    transform: scale(0);
    transition: 120ms transform ease-in-out;
    box-shadow: inset 1em 1em $morado50;
  }

  input[type="radio"]:checked::before {
    transform: scale(1);
  }

  input[type="radio"]:focus {
    border: 0.15em solid $morado50;
  }
}
.border-card {
  border: solid 2px $morado50 !important;
}

.custom-padding {
  @media (max-width: 768px) {
    padding: 0 24px;
  }
  @media (min-width: 769px) {
    padding: 0 76px;
  }
}
.step-1-content {
  .h4-header-title {
    font-family: "Poppins-Bold", sans-serif;
    margin-bottom: 16px;
    color: $neutralBlack;
    @media (max-width: 768px) {
      font-size: 20px;
      line-height: 28px;
    }
    @media (min-width: 769px) {
      font-size: 32px;
      line-height: 42px;
    }
  }
  .p-subtitule-title {
    font-family: "Poppins-Regular", sans-serif;
    margin-bottom: 0px;
    color: $neutralBlack;
    font-size: 16px;
    line-height: 24px;
  }
  padding: 45px 0 56px;
  @include media-breakpoint-down(sm) {
    padding: 30px 0 125px;
  }
  .question-form {
    font-style: normal;
    font-size: 18px;
    line-height: 26px;
    font-family: "Poppins-Medium", sans-serif;
    margin-bottom: 15px;
    color: $neutralBlack;
    .circulo {
      line-height: 26px;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      background: $amarrillo50;
      margin-right: 5px;

      span {
        color: $neutralBlack;
        font-family: "Poppins-Regular", sans-serif;
        font-size: 16px;
        line-height: 24px;
      }
    }
  }

  .pdvxImg {
    width: 100%;
    border-radius: 20px;
  }
  .custom-list {
    @include media-breakpoint-up(sm) {
      margin-left: -15px;
    }
    li {
      p {
        line-height: 16px;
        font-size: 14px;
        @include alternative-light-regular;
        position: relative;
        padding-left: 18px;
        color: $gray-dark;
        margin-bottom: 0;
        &:before {
          content: "";
          width: 6px;
          height: 6px;
          background: $gray-light;
          border-radius: 50%;
          position: absolute;
          left: 2px;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
  }
  .pdv-form-group {
    input[type="text"] {
      border: 1.2px solid #000000;
    }
    label {
      display: block;
      color: #1b1b1d;
      font-size: 14px;
      line-height: 22px;
      font-family: "Poppins-Regular", sans-serif;

      &.checkbox-label {
        display: flex;
        align-items: center;
        margin-bottom: 0;
      }
    }
    .location-container {
      padding-top: 3px;
    }
  }

  .address-item {
    border-radius: 8px;
    border: solid 2px #0c0b0b;
    background: #ffd200;
    padding: 16px;
    margin-bottom: 32px;

    ul {
      padding-left: 0;
      margin-bottom: 0;
      li {
        list-style: none;
        margin-bottom: 8px;
        display: flex;
        align-items: center;
        p {
          color: $neutralBlack;
          font-size: 14px;
          line-height: 22px;
          font-family: "Poppins-Regular", sans-serif;
          margin-bottom: 0;
        }
        span {
          width: 20px;
          height: 20px;
          display: inline-flex;
          justify-content: center;
          margin-right: 5px;
          img {
            height: 20px;
          }
        }
      }
    }

    .custom-list {
      list-style: none !important;
      margin-left: 2px !important;
      li {
        p::before {
          content: "";
          width: 6px;
          height: 6px;
          background: $neutralBlack;
          border-radius: 50%;
          position: absolute;
          left: 2px;
          top: 50%;
          -webkit-transform: translateY(-50%);
          transform: translateY(-50%);
        }
      }
    }
  }

  .academic-programs {
    height: 50px;
    label {
      .check-box-text {
        display: flex;
        align-items: center;
        img {
          width: 31px;
          margin-right: 5px;
          &.help {
            width: 24px;
            margin-left: 5px;
          }
        }
        p {
          margin-bottom: 0;
          font-family: "Poppins-Medium", sans-serif;
          color: $neutralBlack;
          font-size: 16px;
          line-height: 24px;
        }
        span {
          font-size: 13px;
          @include alternative-light-regular;
          padding: 0 5px;
          color: #fff;
          margin-left: 3px;
        }
      }
    }
    &:hover .labelWarning {
      visibility: visible;
    }
    .labelWarning {
      color: red;
      visibility: hidden;
      font-size: 10px;
    }
  }

  .map-container {
    height: 100%;
    iframe {
      @include media-breakpoint-down(sm) {
        height: 300px;
      }
    }
  }
  .month-start {
    p {
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
        "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
        "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
      font-style: normal;
      font-weight: bold;
      font-size: 14px;
      line-height: 14px;
      padding-left: -15px !important;
    }
    span {
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
        "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
        "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
      font-style: normal;
      font-weight: bold;
      font-size: 14px;
      line-height: 14px;
    }
  }
  .month-container {
    padding: 16px 16px 17px 15px;
    font-size: 15px;
    align-content: center;
    text-align: center;
    cursor: pointer;

    @include media-breakpoint-down(sm) {
      width: 100%;
      margin-bottom: 10px;
    }

    &.active {
      background-color: $yellow;
      color: $black;
      &:hover {
        background-color: black;
        color: $yellow;
      }
    }
    &.deactive {
      background-color: $black;
      color: $yellow;
      &:hover {
        background-color: #f8e71c;
        color: $black;
        fill: $black !important;
      }
    }

    span {
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
        "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
        "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
      font-style: normal;
      font-weight: bold;
      font-size: 15px;
      line-height: 17px;
      text-transform: capitalize;
      margin-left: 5px;
    }
  }
  .custom-checkbox-cont {
    @include media-breakpoint-down(sm) {
      margin-bottom: 20px;
    }
  }
}

.pdv-submit-button {
  .form-group {
    margin-bottom: 0;

    .link-error-activator {
      display: inline-block;
    }
  }
  @include media-breakpoint-down(sm) {
    position: fixed;
    width: 100%;
    padding: 23px 16px;
    box-shadow: 0 -2px 6px 0 rgba(0, 0, 0, 0.1);
    bottom: 0;
    left: 0;
    z-index: 99;
    background: #fff;
  }
}

.custom-search-input {
  width: 100%;
  ::placeholder {
    color: lightgray;
  }
}

.box-error-activator {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.element-disabled {
  opacity: 0.3;
  cursor: default;
  pointer-events: none;
}

.disabled-courses-message {
  border-radius: 8px;
  border: 1px solid $warning30;
  background: #fffaf0;
  display: flex;
  align-items: flex-start;
  padding: 14px;
  img {
    margin-right: 10px;
    margin-top: 5px;
    width: 18px;
  }
  p {
    color: $warning80;
    font-family: "Poppins-Regular", sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    margin-bottom: 0;
  }
  ul {
    margin-bottom: 14px;
    padding-left: 15px;
    li {
      color: $warning80;
      font-family: "Poppins-Regular", sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px;
      margin-bottom: 0;
    }
  }
  .disabled-courses {
    color: $warning80;
    font-family: "Poppins-Bold", sans-serif;
    font-size: 14px;
    font-style: normal;
    line-height: 22px;
    margin-bottom: 0;
  }
}
.desc-collapse {
  margin-top: 30px;
  border-radius: 8px;
  border: 1px solid $warning30;
  background: #fffaf0;
  display: flex;
  align-items: flex-start;
  padding: 14px;
  width: 100%;

  .h4-header-title {
    color: $warning80 !important;
    font-family: "Poppins-Bold", sans-serif;
    font-size: 16px;
    line-height: 120%;
  }

  p {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    color: $warning80;
    font-family: "Poppins-Regular", sans-serif;
    margin: 0;
  }
}

.desc-title {
  display: flex;
  margin-bottom: 10px;

  .desc-img {
    width: 24px;
    height: 24px;
    margin-right: 10px;
  }

  p {
    font-family: "ubuntubold", Arial, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 120%;
    color: #656565;
    margin: 0;
  }
  .black {
    font-family: "ubuntubold", Arial, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 120%;
    color: #000000 !important;
  }
}

.initial-text {
  font-family: "ubuntu_lightregular", Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 140%;
  color: #656565;
  margin: 0;
  span {
    font-family: "ubuntu_lightregular", Arial, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 140%;
    color: #656565;
    margin: 0;
  }
}

.desc-button {
  margin-top: 10px;
  background: transparent;
  font-family: "ubuntubold", Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 120%;
  color: #000000 !important;
  cursor: pointer;
}

.desc-icon {
  font-family: "ubuntubold", Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 120%;
  color: #ffcb5b;
  margin-right: 5px;
}

.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}
.s-b {
  margin-bottom: 11px;
}
.orange-borde {
  border: solid 4px #f4d04d;
}

.flex {
  display: flex;
}

.note-mobile {
  display: none;
  background: #fafafa;
  border: 1px solid #ededed;
  box-sizing: border-box;
  padding: 20px;
  @include alternative-regular;
  width: 100%;
  @media screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
  }
}

.texto-resaltado {
  background: rgba(244, 208, 77, 0.1);
  border-radius: 4px;
  box-sizing: border-box;
  padding: 18px;
  @include alternative-regular;
  width: 100%;
  text-align: justify;
  @media screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    margin-top: 20px;
  }
}

.title-note {
  @include alternative-regular;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 139%;
  color: #ff0000;
  margin-bottom: 20px;
}
.text-note {
  @include alternative-regular;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 139%;
  margin: 0;
}

.relative {
  position: relative;
}

.custom-aligment {
  @media screen and (min-width: 769px) {
    position: absolute;
    right: 0px;
    top: 0px;
  }
}

.m-title {
  margin-bottom: 40px;
}
</style>
<style lang="scss">
.form-label-multiselect {
  color: $neutralBlack;
  font-size: 14px;
  line-height: 22px;
  font-family: "Poppins-Regular", sans-serif;
  margin-bottom: 9px;
}
.multiselect-custom {
  .multiselect__tags {
    font-size: 16px;
    line-height: 18px;
    font-family: "ubunturegular", Arial, sans-serif;
    background: transparent !important;
    height: 52.38px;
    border-radius: 100px;
    border: 2px solid $neutral30;
    display: flex;
    align-items: center;
    padding: 0 24px;
  }
  &.multiselect--active {
    .multiselect__select:before {
      top: 60%;
    }
  }
  .multiselect__select:before {
    top: 55%;
  }
  .multiselect__select {
    height: 100%;
  }
  .multiselect__element {
    span {
      color: $neutral50;
      font-family: "Poppins-Medium", sans-serif !important;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px;

      &:hover {
        background: $neutral05;
      }
      &.multiselect__option--highlight {
        background: $neutral05;
      }
    }
    .multiselect__option--selected {
      background: $neutral05;
    }
  }

  &.multiselect--active.multiselect--above {
    .multiselect__tags {
      border-top-left-radius: 100px !important;
      border-top-right-radius: 100px !important;
    }
  }

  &.multiselect--active:not(.multiselect--above) {
    .multiselect__tags {
      border-bottom-left-radius: 100px !important;
      border-bottom-right-radius: 100px !important;
    }
  }
  .multiselect__input {
    margin-bottom: 0px !important;
  }
  .multiselect__placeholder,
  .multiselect__single {
    margin-bottom: 0px !important;
    color: $neutral50;
    font-family: "Poppins-Regular", sans-serif !important;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    background-color: transparent !important;
  }
}
.gap-40 {
  gap: 40px;
}

.badge-subject {
  font-family: "Poppins-Medium", sans-serif !important;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
  padding: 1px 8px !important;
  border-radius: 8px !important;
}
</style>
